module.exports = __webpack_public_path__ + "img/img-3-15mobile.68b82835.png";